import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Select, Store } from '@ngxs/store';
import { AccountService, AuthorizationActions, ModulesSelectors, ValidationsService } from '@serviceos-ng/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'serviceos-web-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
    @Output()
    public changeScreenEvent = new EventEmitter();

    @Select(ModulesSelectors.getModuleConfigText('auth'))
    moduleAuthTexts$!: Observable<any>;

    public resetPasswordForm: FormGroup;
	public formErrorMessage = '';
    public confirmationEmail = '';
    public emailSent = false;
    public formErrors: any[] = [];
    public showLocalLoader = false;

    public componentSettings = {
        fields: {
            email: {
                label: 'Email',
                placeholder: '',
                errMsgs: {
                    required: 'Please enter your email address!',
                    format: 'Email is invalid',
                },
            },
            submitButton: {
                label: 'Send reset link',
                type: 'button',
            },
        },
        errorMessages: [],
    };

    constructor(
        private fb: FormBuilder,
        private _validationService: ValidationsService,
		private _accountService: AccountService,
        private store: Store
    ) {
        this.resetPasswordForm = this.fb.group({
            email: [
                '',
                [
                    Validators.required,
                    Validators.pattern(
                        this._validationService.getPattern('register', 'email')
                    ),
                ],
            ],
        });
    }

    ngOnInit(): void {}

    public processForm() {
        if (this.resetPasswordForm.valid) {
            const formValue = this.resetPasswordForm.value;

            const formData = {
                email: formValue.email,
            };

            this.showLocalLoader = true;

            this.store.dispatch(new AuthorizationActions.RequestResetPassword(formData))
            .pipe(
                finalize(() => {
                    this.showLocalLoader = false;
                })
            )
			.subscribe(
                (res) => {
                    this.formErrorMessage = '';
                    this.emailSent = true;
                    this.confirmationEmail = formValue.email;
                },
                (error) => {
                    this.formErrorMessage = error?.error[0]?.message;
                }
            );
        }
    }

    public changeScreenHandler(screen) {
        this.changeScreenEvent.emit(screen);
    }

    /**
     * Geter for field in reset password form
     */
    get email() {
        return this.resetPasswordForm.get('email');
    }
}
